'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { template } from '#pplx/frontend/framework/templates/template.js';
const HomeSideCardSlotRoot = ({ children, ref }) => (_jsx("div", { ref: ref, "data-upsell-slot": "ask.home.side_card", children: children }));
const AskUpsellSlotsLayout = ({ Slot }) => (_jsx(Slot, { slot: "homeSideCard" }));
export const AskUpsellSlotsTemplate = template('AskUpsellSlotsTemplate')
    .slot('homeSideCard', HomeSideCardSlotRoot)
    .define(AskUpsellSlotsLayout);
//# sourceMappingURL=AskUpsellSlotsTemplate.js.map